module.exports = __webpack_public_path__ + "img/Pattern04.6f9cb747.png";